<template>
    <div id="main-grid" class="grid simple main borderRadius12px" style="background: #e5e9ec">
      <div class="well form-group" style="background: #e5e9ec">
  
        <!--title -->
        <div class="grid-title no-border borderTop">
          <h4 style="padding-left: 6px"> {{ i18nValues["carrierCompanyEdition"] }} </h4>
        </div>        
  
        <!-- body -->
        <div class="grid-body no-border borderBottom">
          <el-form v-loading="loading != 0" :model="carrierCompany" ref="formCarrierCompany" :rules="rules">
            <div class="gridTemplate">
  
                <!-- CarrierCompany -->    
                <el-form-item :label="i18nValues['carrierCompany']" prop="name"> 
                  <el-input v-model="carrierCompany.name" maxlength="30"></el-input>
                </el-form-item>      
  
            </div>          
          </el-form>
  
          <!-- CANCEL/SAVE --> 
          <div class="full-width d-flex justify-content-end mt-2">
            <el-button :loading="loading" size="small" @click="cancel()">
              {{ i18nValues["cancel"] }}
            </el-button>
            <el-button v-if="!isReadOnly()" icon="fas fa-check" :loading="loading" size="small" class="btn-primary" @click="save()">
              {{ i18nValues["save"] }}
            </el-button>
          </div>  
  
        </div>      
      </div>
    </div>
  </template>
  
  <script>
  import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
  export default {
    name: "CarrierCompanyEdition",  
  
    created(){

      if(this.id != 0 ){
        this.retrieveById();
      } else {
        this.carrierCompany.creationUser = this.user.name;
        this.carrierCompany.creationDate = new Date();
      }

    this.rules= {
        name:[{required: true, message: this.i18nValues["requiredValue"], trigger: 'blur' }],
      };

    // Capture initial query to preserve filters/pagination when returning
    this.returnQuery = { ...this.$route.query };
  
    },
  
    components: {
      
    },
  
    computed: {
      loading: get("carrier/loading"),
    },

    props:["id"],
  
    data() {
      return {

        carrierCompany: {},
      
      returnQuery: {},
  
      };
    },
  
    methods: {
      save(){
        this.$refs["formCarrierCompany"].validate(valid => {
          if(valid){
            this.$store.dispatch("carrier/saveCarrierCompany", this.carrierCompany).then((res) =>{            
              if(res.status == "OK"){
                  this.$notify.success({
                      title: this.i18nValues["succes"],
                      message: this.i18nValues["carrierCompanySaved"],
                      position: "bottom-right",
                  });
                  this.$router.push({name:"CarrierCompanyAdmin", query: this.returnQuery});
              } else {
                  this.$notify.error({
                      title: this.i18nValues["error"],
                      message: "Ha ocurrido un error",
                      position: "bottom-right",
                  });
              }           
            });
          }
        });
      },
  
      cancel(){
          this.$router.push({name:"CarrierCompanyAdmin", query: this.returnQuery});
      },

      retrieveById(){
        this.$store.dispatch("carrier/retrieveCarrierCompanyById", { id: this.id }).then((res)=>{
            this.carrierCompany = res;
            this.carrierCompany.modificationUser = this.user.name;
            this.carrierCompany.modificationDate = new Date();
        });       
      },
  
    },
  
  
  }
  </script>
  
  <style>
  
  </style>